<div class="shift-compliance-container">
	<img
		class="d-none d-lg-block hero-bg"
		src="../assets/img/hero-bg.svg"
		alt=""
	/>
	<img
		class="d-block d-lg-none hero-bg-mobile"
		src="../assets/img/hero-bg-mobile.svg"
		alt=""
	/>
	<div
		class="
			d-flex
			flex-column flex-md-row
			align-items-center
			justify-content-md-end
		"
	>
		<div></div>
		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				It’s Time to Shift Compliance Left
			</h1>
			<p class="shift-compliance-para mt-4">
				Improve business agility. Lower costs. <br />
				Create compliance superheroes.
			</p>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="mt-4 shift-compliance-btn bg-white py-2 px-4">
					Find Out How
					<i class="ml-2 fas fa-long-arrow-alt-down"></i></button
			></a>
		</div>
	</div>

	<div class="shift-compliance-bottom">
		<h2 class="trusted-header mb-5">
			Trusted by Local and Global Organizations
		</h2>
		<img
			class="d-none d-md-block"
			width="100%"
			src="../../assets/img/global-organizations.png"
			alt=""
		/>

		<swiper [config]="swiperConfig" class="d-md-none myTestimonialsSwiper">
			<ng-template swiperSlide>
				<div class="testimonials-slide-item">
					<img
						width="150px"
						src="../../assets/img/johnson-controls.png"
						alt=""
					/>
				</div> </ng-template
			><ng-template swiperSlide>
				<div class="testimonials-slide-item">
					<img
						width="100px"
						src="../../assets/img/Seal_of_the_United_States_Department_of_Homeland_Security.png"
						alt=""
					/>
				</div>
			</ng-template>
			<ng-template swiperSlide>
				<div class="testimonials-slide-item">
					<img
						width="120px"
						src="../../assets/img/air-force.png"
						alt=""
					/>
				</div>
			</ng-template>
			<ng-template swiperSlide>
				<div class="testimonials-slide-item">
					<img
						width="150px"
						src="../../assets/img/TN_TDOT-ColorPMS.png"
						alt=""
					/>
				</div>
			</ng-template>
			<ng-template swiperSlide>
				<div class="testimonials-slide-item">
					<img
						width="200px"
						src="../../assets/img/rtx_logo-01 1.png"
						alt=""
					/>
				</div>
			</ng-template>
		</swiper>
	</div>
</div>
